var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInActiveCalenderComponetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39734 3H17.8058C19.6311 3 21.1016 4.47042 21.1016 6.29577V17.7042C21.1016 19.5296 19.6311 21 17.8058 21H6.39734C4.57199 21 3.10156 19.5296 3.10156 17.7042V6.29577C3.10156 4.47042 4.57199 3 6.39734 3Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 100
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1014 7.61328H3",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 100
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91758 11.8742C7.76547 11.8742 7.66406 11.7728 7.66406 11.6207C7.66406 11.4686 7.76547 11.3672 7.91758 11.3672C8.0697 11.3672 8.1711 11.4686 8.1711 11.6207C8.1711 11.7728 8.0697 11.8742 7.91758 11.8742Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 100
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91758 16.4367C7.76547 16.4367 7.66406 16.3353 7.66406 16.1832C7.66406 16.0311 7.76547 15.9297 7.91758 15.9297C8.0697 15.9297 8.1711 16.0311 8.1711 16.1832C8.1711 16.3353 8.0697 16.4367 7.91758 16.4367Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 100
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2281 11.8742C12.076 11.8742 11.9746 11.7728 11.9746 11.6207C11.9746 11.4686 12.076 11.3672 12.2281 11.3672C12.3802 11.3672 12.4817 11.4686 12.4817 11.6207C12.4817 11.7728 12.3802 11.8742 12.2281 11.8742Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 100
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5387 11.8742C16.3866 11.8742 16.2852 11.7728 16.2852 11.6207C16.2852 11.4686 16.3866 11.3672 16.5387 11.3672C16.6908 11.3672 16.7922 11.4686 16.7922 11.6207C16.7922 11.7728 16.6908 11.8742 16.5387 11.8742Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 100
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2281 16.4367C12.076 16.4367 11.9746 16.3353 11.9746 16.1832C11.9746 16.0311 12.076 15.9297 12.2281 15.9297C12.3802 15.9297 12.4817 16.0311 12.4817 16.1832C12.4817 16.3353 12.3802 16.4367 12.2281 16.4367Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 100
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActiveCalenderComponetIcon);
export default __webpack_public_path__ + "static/media/InActiveCalenderComponetIcon.82ad9926239f796e7f106c404a052031.svg";
export { ForwardRef as ReactComponent };